require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-mattersburg-bad-sauerbrunn.json") })
        }
      }, "path---betreuungseinrichtungen-mattersburg-bad-sauerbrunn");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-mattersburg-bad-sauerbrunn!./.cache/json/betreuungseinrichtungen-mattersburg-bad-sauerbrunn.json
// module id = 924
// module chunks = 231608221292675